module.exports = __webpack_public_path__ + "static/media/placeholder-2.be00920e.svg";